import React from 'react';
import { COLORS, FONTS, primaryButtonStyle } from './signupStyles';

const TrustIcon = ({ children }) => (
  <div style={{
    flexShrink: 0, width: '36px', height: '36px', borderRadius: '10px',
    background: 'rgba(232, 160, 144, 0.08)',
    display: 'flex', alignItems: 'center', justifyContent: 'center'
  }}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
      strokeWidth="1.8" stroke={COLORS.salmon} style={{ width: '18px', height: '18px' }}>
      {children}
    </svg>
  </div>
);

const TrustPoint = ({ icon, label }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', textAlign: 'left' }}>
    <TrustIcon>{icon}</TrustIcon>
    <span style={{ fontSize: '0.9rem', color: '#6b6460', lineHeight: '1.4' }}
      dangerouslySetInnerHTML={{ __html: label }} />
  </div>
);

export const StepWelcome = ({ onNext }) => (
  <div style={{
    minHeight: '80vh',
    backgroundColor: COLORS.bg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    position: 'relative',
    fontFamily: FONTS.system,
    padding: '80px 20px 40px'
  }}>
    <style>{`
      @keyframes fadeUp {
        from { opacity: 0; transform: translateY(16px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .signup-cta-button:hover {
        background-color: #3a3a39 !important;
        transform: translateY(-1px) !important;
      }
      .signup-cta-button:active {
        transform: translateY(0) !important;
      }
    `}</style>

    <div style={{
      position: 'relative', zIndex: 1, width: '100%', maxWidth: '480px',
      animation: 'fadeUp 0.6s ease-out'
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 4px 40px rgba(0,0,0,0.04), 0 1px 3px rgba(0,0,0,0.02)',
        padding: '48px 40px 40px',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontFamily: FONTS.serif,
          fontSize: 'clamp(24px, 5vw, 32px)',
          fontWeight: 700,
          lineHeight: 1.2,
          color: COLORS.text,
          marginBottom: '16px',
          letterSpacing: '-0.01em'
        }}>
          Share your experience.{' '}
          <span style={{
            background: 'linear-gradient(180deg, transparent 58%, rgba(232,160,144,0.28) 58%)',
            paddingBottom: '2px'
          }}>
            Get paid for it.
          </span>
        </h1>

        <p style={{
          fontSize: '1.05rem', lineHeight: 1.55,
          color: '#6b6460', marginBottom: '32px', fontWeight: 400
        }}>
          Tell us what living with your condition is actually like — and help shape the future of treatment.
        </p>

        <button
          className="signup-cta-button"
          onClick={onNext}
          style={{
            ...primaryButtonStyle,
            display: 'block',
            width: '100%',
            padding: '16px 24px'
          }}
        >
          Get Started
        </button>

        <div style={{
          height: '1px', margin: '28px 0',
          background: 'linear-gradient(90deg, transparent, rgba(0,0,0,0.06), transparent)'
        }} />

        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <TrustPoint
            icon={<path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />}
            label="<strong style='color:#272726;font-weight:600'>Earn $75–$500</strong> per research study"
          />
          <TrustPoint
            icon={<path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />}
            label="<strong style='color:#272726;font-weight:600'>You control</strong> what you share"
          />
          <TrustPoint
            icon={<path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />}
            label="<strong style='color:#272726;font-weight:600'>Join patients</strong> sharing real experiences"
          />
        </div>
      </div>
    </div>
  </div>
);
